/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeNavs.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Navs Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Tuesday, September 18, 2018 - 9:25 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/18/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const NAV_LIST_CONTAINER_LOADED = 'NAV_LIST_CONTAINER_LOADED';
export const NAV_LIST_CONTAINER_UNLOADED = 'NAV_LIST_CONTAINER_UNLOADED';

export const NAV_LIST_TABLE_LOADED = 'NAV_LIST_TABLE_LOADED';
export const NAV_LIST_TABLE_UNLOADED = 'NAV_LIST_TABLE_UNLOADED';

export const NAV_LIST_CHANGE_NAVGROUP_SELECT = 'NAV_LIST_CHANGE_NAVGROUP_SELECT';

export const NAV_SELECT_ROW = 'NAV_SELECT_ROW';
export const NAV_ADD = 'NAV_ADD';
export const NAV_EDIT = 'NAV_EDIT';
export const NAV_DELETE = 'NAV_DELETE';
export const NAV_DELETE_DISABLE = 'NAV_DELETE_DISABLE';
export const NAV_OPEN_WARNING = 'NAV_OPEN_WARNING';
export const NAV_CLOSE_WARNING = 'NAV_CLOSE_WARNING';
export const NAV_VIEW_NAVS = 'NAV_VIEW_NAVS';


export const NAV_EDIT_CONTAINER_LOADED = 'NAV_EDIT_CONTAINER_LOADED';
export const NAV_EDIT_CONTAINER_UNLOADED = 'NAV_EDIT_CONTAINER_UNLOADED';

export const NAV_EDIT_FORM_LOADED = 'NAV_EDIT_FORM_LOADED';
export const NAV_EDIT_FORM_UNLOADED = 'NAV_EDIT_FORM_UNLOADED';
export const NAV_EDIT_DATA_LOAD = 'NAV_EDIT_DATA_LOAD';
export const NAV_EDIT_CONTAINER_CANCEL = 'NAV_EDIT_CONTAINER_CANCEL';

export const NAV_EDIT_LOAD_NAVTYPE_SELECT = 'NAV_EDIT_LOAD_NAVTYPE_SELECT';
export const NAV_EDIT_DRAW_NAVTYPE_SELECT = 'NAV_EDIT_DRAW_NAVTYPE_SELECT';
export const NAV_EDIT_LOAD_COMPONENTGROUP_SELECT = 'NAV_EDIT_LOAD_COMPONENTGROUP_SELECT';
export const NAV_EDIT_DRAW_COMPONENTGROUP_SELECT = 'NAV_EDIT_DRAW_COMPONENTGROUP_SELECT';
export const NAV_EDIT_LOAD_COMPONENT_SELECT = 'NAV_EDIT_LOAD_COMPONENT_SELECT';
export const NAV_EDIT_DRAW_COMPONENT_SELECT = 'NAV_EDIT_DRAW_COMPONENT_SELECT';


// WEBPACK FOOTER //
// ./src/constants/actionTypeNavs.js